export default {
   changeLang(context, lang) {
      context.commit('changeLang', lang);
   }
}